// extracted by mini-css-extract-plugin
export var popupCloseBtn = "Privacy-module--popup-close-btn--fffb5";
export var popupContent = "Privacy-module--popup-content--76c94";
export var popupContentSection = "Privacy-module--popup-content-section--d7454";
export var popupContentSectionTitle = "Privacy-module--popup-content-section-title--47b1c";
export var popupContentTitle = "Privacy-module--popup-content-title--1cdc5";
export var popupInner = "Privacy-module--popup-inner--55da8";
export var privacyPopup = "Privacy-module--privacy-popup--33f70";